import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    panel: 0,
    year: null,
    make: null,
    model: null,
    attributes: {},
    variations: {},
    optionPrices: {},
    accessories: {},
    pricing: 'retailPrice',
    src: null,
    coupon: null,
    giftCard: null,
    customer: null,
    addresses: [],
    order: null
  },
  mutations: {
    setLoading (state, loading) {
      state.loading = loading
    },
    next (state) {
      state.panel++
    },
    previous (state) {
      state.panel--
    },
    goTo (state, index) {
      state.panel = index
    },
    setYear (state, year) {
      state.year = year
    },
    setMake (state, make) {
      state.make = make
    },
    setModel (state, model) {
      state.model = model
    },
    setAttributes (state, attrs) {
      state.attributes = attrs
    },
    setVariations (state, { row, ...variation }) {
      Vue.set(state.variations, row, variation)
    },
    deleteVariations (state, row) {
      Vue.delete(state.variations, row)
    },
    resetVariations (state) {
      state.variations = {}
    },
    addOption (state, option) {
      const selected = state.variations[option.position].options[option.index]
      const { added, style, color } = option
      Vue.set(state.variations[option.position].options, option.index, {...selected, added, style, color})
    },
    setOptionPrices (state, prices) {
      state.optionPrices = prices
    },
    setAccessories (state, products) {
      state.accessories = products
    },
    addAccessory (state, { part, added, quantity }) {
      Vue.set(state.accessories, part, { ...state.accessories[part], added, quantity })
    },
    setPricing (state, pricing) {
      state.pricing = pricing
    },
    setCoupon (state, coupon) {
      state.coupon = coupon
    },
    setGiftCard (state, giftcard) {
      state.giftCard = giftcard
    },
    setCustomer (state, customer) {
      state.customer = customer
    },
    setAddresses (state, addresses) {
      state.addresses = addresses
    },
    setOrder (state, order) {
      state.order = order
    },
    setSrc (state, src) {
      state.src = src
    }
  },
  getters: {
    priceMaterial: state => pricing => {
      if (pricing === 'wholesale') {
        return `tier${state.customer?.discountIndex}Price`
      }
      return pricing
    },
    priceOption: (state, getters) => pricing =>  {
      if (pricing === 'retailPrice') {
        return 'RetailPrice'
      }
      return getters.priceMaterial(pricing)
    },
    priceAccessory: (state, getters) => pricing =>  {
      return pricing === 'retailPrice' ? 'retailPrice' : getters.priceMaterial(pricing)
    },
    getSeatPrice: (state, getters) => (row, pricing) => {
      let price = 0
      const trim = row.trim ? row.prices[row.trim.materialId][getters.priceMaterial(pricing)] : 0
      const insert = row.insert ? row.prices[row.insert.materialId][getters.priceMaterial(pricing)] : 0

      price += Math.max(trim, insert)

      Object.values(row.options).forEach(option => {
        if (option.added) {
          price += option[getters.priceOption(pricing)]
        }
      })

      return price
    },
    getProductPrice: (state, getters) => (product, pricing) => {
      return product.added
        ? product[getters.priceAccessory(pricing)] * parseInt(product.quantity)
        : 0
    },
    freeShipping: (state) => {
      return state.coupon?.freeShippingLower48
    },
    getSeatTotal: (state, getters) => pricing => {
      let total = 0
      Object.values(state.variations).forEach(row => {
        total += getters.getSeatPrice(row, pricing)
      })
      return total
    },
    getAccTotal: (state, getters) => pricing => {
      let acctotal = 0
      Object.values(state.accessories).forEach(product => {
        acctotal += getters.getProductPrice(product, pricing)
      })
      return acctotal
    },
    getSubtotal: (state, getters) => pricing => {
      return getters.getSeatTotal(pricing) + getters.getAccTotal(pricing)
    },
    subtotal: (state, getters) => {
      return getters.getSubtotal(state.pricing)
    },
    discount: (state, getters) =>
      state.coupon
        ? (getters.subtotal * state.coupon.discountPercent / 100).toFixed(2)
        : 0,
    discountedTotal: (state, getters) => {
      return getters.subtotal - getters.discount
    },
    isUTV: state => state.model?.vehicleType === 'UTV',
    accessoriesList: (state) => Object.values(state.accessories)
  },
  actions: {
  },
  modules: {
  }
})
